import { useGetApiDashboardListingContrats } from '@/api';
import { USER_TYPE } from '@/enums/userType';
import { useAuth } from '@/hooks/useAuth';

const useListingContrats = () => {
  const { user } = useAuth();

  return useGetApiDashboardListingContrats({
    query: {
      enabled: user?.type === USER_TYPE.client,
    },
  });
};

export { useListingContrats };
